import React from 'react'
import top from '../assets/top.png'
const Contact = () => {
  return (
    <>
      <div class="relative flex h-auto min-h-screen w-full flex-col group/design-root overflow-x-hidden">
            <div class="layout-container flex h-full grow flex-col">
                <div class="flex flex-1 justify-center py-5 sm:px-10 md:px-20 lg:px-40">
                <div class="layout-content-container flex flex-col max-w-[960px] flex-1">

                <main class="flex flex-col">
                <div class="w-full">
                <div class="flex flex-col gap-6 px-4 py-10 @[480px]:gap-8 @[864px]:flex-row">
                <div class="flex flex-col gap-6 @[480px]:gap-8 @[864px]:justify-center w-full">
                <div class="flex flex-col gap-2 text-left">
                <h1 class="text-4xl font-black leading-tight tracking-[-0.033em] @[480px]:text-5xl text-primary">How Can We Help?</h1>
                <p class="text-sm font-normal leading-normal @[480px]:text-base text-subtext-light dark:text-subtext-dark">We're here to answer your questions. Find the right contact information or use our form to get in touch with our team.</p>
                </div>
                </div>
                   </div>
                </div>


                <h2 class="text-2xl font-bold leading-tight tracking-[-0.015em] px-4 pb-3 pt-5">Find the Right Contact</h2>



                <div class="grid grid-cols-[repeat(auto-fit,minmax(200px,1fr))] gap-4 p-4">
                <div class="flex flex-1 gap-3 rounded-lg border border-secondary dark:border-gray-700 bg-white dark:bg-background-dark p-4 flex-col">
                <span class="material-symbols-outlined text-accent" style={{fontSize: "24px;"}}>info</span>
                <div class="flex flex-col gap-1">
                <h3 class="text-base font-bold leading-tight">General Inquiries</h3>
                <p class="text-sm font-normal leading-normal text-subtext-light dark:text-subtext-dark">For media relations and general questions about our company.</p>
                </div>
                </div>
                <div class="flex flex-1 gap-3 rounded-lg border border-secondary dark:border-gray-700 bg-white dark:bg-background-dark p-4 flex-col">
                <span class="material-symbols-outlined text-accent" style={{fontSize: "24px"}}>medical_services</span>
                <div class="flex flex-col gap-1">
                <h3 class="text-base font-bold leading-tight">Medical Information</h3>
                <p class="text-sm font-normal leading-normal text-subtext-light dark:text-subtext-dark">For healthcare professionals seeking product information.</p>
                </div>
                </div>
                <div class="flex flex-1 gap-3 rounded-lg border border-secondary dark:border-gray-700 bg-white dark:bg-background-dark p-4 flex-col">
                <span class="material-symbols-outlined text-accent" style={{fontSize: "24px"}}>support_agent</span>
                <div class="flex flex-col gap-1">
                <h3 class="text-base font-bold leading-tight">Patient Support</h3>
                <p class="text-sm font-normal leading-normal text-subtext-light dark:text-subtext-dark">Assistance for patients using our products and programs.</p>
                </div>
                </div>
                <div class="flex flex-1 gap-3 rounded-lg border border-secondary dark:border-gray-700 bg-white dark:bg-background-dark p-4 flex-col">
                <span class="material-symbols-outlined text-accent" style={{fontSize: "24px"}}>work</span>
                <div class="flex flex-col gap-1">
                <h3 class="text-base font-bold leading-tight">Career Opportunities</h3>
                <p class="text-sm font-normal leading-normal text-subtext-light dark:text-subtext-dark">Explore opportunities to join our innovative team.</p>
                </div>
                </div>
                </div>



                <section class="p-4 mt-8">
                <div class="p-6 sm:p-8 rounded-xl bg-white dark:bg-gray-800 border border-secondary dark:border-gray-700">
                <h2 class="text-2xl font-bold leading-tight tracking-[-0.015em] mb-6">Send Us a Message</h2>
                <form action="#" class="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
                <div>
                <label class="block text-sm font-medium mb-1.5" for="first-name">First Name</label>
                <input class="w-full rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:ring-primary focus:border-primary" id="first-name" type="text"/>
                </div>
                <div>
                <label class="block text-sm font-medium mb-1.5" for="last-name">Last Name</label>
                <input class="w-full rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:ring-primary focus:border-primary" id="last-name" type="text"/>
                </div>
                <div class="md:col-span-2">
                <label class="block text-sm font-medium mb-1.5" for="email">Email</label>
                <input class="w-full rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:ring-primary focus:border-primary" id="email" type="email"/>
                </div>
                <div class="md:col-span-2">
                <label class="block text-sm font-medium mb-1.5" for="inquiry-type">Inquiry Type</label>
                <select class="w-full rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:ring-primary focus:border-primary" id="inquiry-type">
                <option>General Inquiries</option>
                <option>Medical Information</option>
                <option>Patient Support</option>
                <option>Careers</option>
                <option>Investor Relations</option>
                </select>
                </div>
                <div class="md:col-span-2">
                <label class="block text-sm font-medium mb-1.5" for="message">Message</label>
                <textarea class="w-full rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700 dark:text-white focus:ring-primary focus:border-primary" id="message" rows="4"></textarea>
                </div>
                <div class="md:col-span-2 flex items-start">
                <div class="flex items-center h-5">
                <input class="h-4 w-4 text-primary rounded border-gray-300 dark:border-gray-600 dark:bg-gray-700 focus:ring-primary" id="consent" type="checkbox"/>
                </div>
                <div class="ml-3 text-sm">
                <label class="text-subtext-light dark:text-subtext-dark" for="consent">By checking this box, you agree to our <a class="font-medium text-primary hover:underline" href="#">Privacy Policy</a>.</label>
                </div>
                </div>
                <div class="md:col-span-2">
                <button class="flex min-w-[84px] cursor-pointer items-center justify-center overflow-hidden rounded-lg h-12 px-5 bg-primary text-white text-base font-bold leading-normal tracking-[0.015em] w-full sm:w-auto" type="submit">
                <span class="truncate">Submit Form</span>
                </button>
                </div>
                </form>
                </div>
                </section>


                <section class="p-4 mt-8">
                <h2 class="text-2xl font-bold leading-tight tracking-[-0.015em] mb-6">Our Locations</h2>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="md:col-span-2 rounded-xl overflow-hidden border border-secondary dark:border-gray-700">
                 <iframe height="450" data-location="Nigeria"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15856.732459079329!2d3.2957764976944373!3d6.498487395897866!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b8f301f76cca9%3A0xdea9c643d6e4fa5c!2sWorld%20wide%20plaza!5e0!3m2!1sen!2sng!4v1763464887723!5m2!1sen!2sng"  style={{border:"0;", width:"100%"}}></iframe>
                </div>
                <div class="flex flex-col gap-6">
                <div class="p-4 rounded-lg bg-white dark:bg-gray-800 border border-secondary dark:border-gray-700">
                <h3 class="font-bold text-lg">Our office</h3>
                <p class="text-sm text-subtext-light dark:text-subtext-dark mt-2">193 worldwide plaza<br/>Ago palace way okota<br/>Lagos nigeria</p>
                <p class="text-sm text-subtext-light dark:text-subtext-dark mt-2">Phone: +234 805 301 9458</p>
                <p class="text-sm text-subtext-light dark:text-subtext-dark mt-2">Email: info@abjpharmacy.com</p>
                </div>
               
                </div>
                </div>
                </section>
                </main>
                </div>
                </div>
          </div>
   </div>
    </>
  )
}

export default Contact
